import { Modal, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import check from "../../assets/svgs/single-check.svg";
import stripe from "../../assets/images/stripe_logo.png";
import rapyd from "../../assets/images/rapyd_logo.png";
import "./PaymentMethod.css";

const PaymentMethod = (props) => {
  const [activePayment, setActivePayment] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [showGatewayModal, setShowGatewayModal] = useState(false);

  useEffect(() => {
    if (props.outletInfo?.method === 1) {
      setActivePayment(0);
      setPaymentMethod(null);
      setShowGatewayModal(false);
    }
    // For delivery (method === 2)does not reset paymentMethod (Rapyd)
  }, [props.outletInfo?.out_id]);

  return (
    <>
      {props.outletInfo?.method === 2 && (
     <Modal show={props.showPayment} onHide={()=> {
       props.setPaymentVisible(false);
       }}
          className="pm-modal"
          dialogClassName="pm-modal-md xs modal-dialog-centered"
          contentClassName="xs"
          centered
          backdrop="static"
        >
          {!showGatewayModal && (
            <>
              <Modal.Header className="pm-header">
                <h4 className="pm-title">Payment Method</h4>
           <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={()=> {
             props.setPaymentVisible(false);
             }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </Modal.Header>
  {/* <div className="pm-container">
              <div className="pm-row">
                {/* Credit/Debit */}
             {/*   <div
                  className={`pm-method btn ${
                    activePayment === 1 ? "pm-active" : ""
                  }`}
                 
                  onClick={() => {
                    setPaymentMethod(paymentMethod || "rapyd");
                    setShowGatewayModal(true);
                    setActivePayment(1);
                  }}
                >
                  Credit/Debit
                  {activePayment === 1 && (
                    <img src={check} alt="tick_mark" className="pm-tick" />
                  )}
                </div>
 
                {/* Cash */}
              {/*</>  <div
                  className={`pm-method btn ${
                    activePayment === 2 ? "pm-active" : ""
                  }`}
                  onClick={() => {
                    setPaymentMethod("cash");
                    setActivePayment(2);
                  }}
                >
                  Cash
                  {activePayment === 2 && (
                    <img src={check} alt="tick_mark" className="pm-tick" />
                  )}
                </div>
              </div>
            </div> */}
              <Modal.Body className="delivery-mode">
          
                <div className="paymentContainer">
                  <div className="pm-row">
             {props.outletInfo?.method === 2 &&
             <div className={`pm-method btn ${ activePayment===1 ? "paymentMethod btn activeMethod"
               : "paymentMethod btn" }`} onClick={()=> {
                          setPaymentMethod("Rapyd");
                          setActivePayment(1);
              //  setShowGatewayModal(true);
                        }}
                      >
                        Credit/Debit

               <img src={check} alt="tick_mark" className={`${activePayment===1 ? "tick" : "tick_disabled" }`} />

                      </div>
}
              {/* {props.outletInfo?.method === 2 &&
             <div className={`pm-method btn ${ activePayment===2 ? "pm-active" : "paymentMethod btn" }`} onClick={()=> {
                          setPaymentMethod("cash");
                          setActivePayment(2);
                        }}
                      >
                        Cash
                        {activePayment === 2 && (
                          <img src={check} alt="tick_mark" className="pm-tick" />
                        )}
             </div> } */}
                  </div>
                </div>

              </Modal.Body>
              <div className="pm-selected">
                Selected option:
           <span className="pm-selected-text" style={{ marginLeft: "2%", fontWeight: "bold", color: "black" }}>
                  {paymentMethod
             ? paymentMethod.charAt(0).toUpperCase() +
             paymentMethod.slice(1)
                    : ""}
                </span>
              </div>

              <Modal.Footer className="pm-footer">
           <button className="btn lg primary d-block" onClick={()=> {
                    props.setPaymentMethod(paymentMethod);
                    props.setPaymentVisible();
            //  if (paymentMethod === "paynow") {
            //  props.setShowPaynow(true);
            //  }
                  }}
                >
                  Proceed
                </button>
              </Modal.Footer>
            </>
          )}
        </Modal>
      )}
     {/* <Modal show={showGatewayModal} onHide={()=> setShowGatewayModal(false)}
       className="pm-nested"
       centered
       backdrop="static"
       animation={true}
       >
       <div className="pm-line-top"></div>

       <Modal.Body>
         <div className="pm-gateway">
           <div className="pm-gateway-label">
             <label>Select Payment Gateway</label>
           </div>

           <div className="pm-line"></div>

           <div className="pm-gateway-boxes">
             {["rapyd", "stripe"].map((gateway) => (
             <div key={gateway} className={`pm-gateway-box ${ paymentMethod===gateway ? "pm-gateway-active" : "" }`}
               onClick={()=> setPaymentMethod(gateway)}
               >
               <img src={gateway==="rapyd" ? rapyd : stripe} alt={gateway} style={{ width: 50 }} />
               {paymentMethod === gateway && (
               <img src={check} alt="tick" className="pm-tick" />
               )}
             </div>
             ))}
           </div>

           <div className="pm-line"></div>

           <div className="pm-buttons">
             <button className="btn btn-secondary" onClick={()=> setShowGatewayModal(false)}
               >
               Cancel
             </button>
             <button className="btn btn-primary" disabled={!paymentMethod}
               style={{ background: "#e01e26", borderColor: "#e01e26" }} onClick={()=> setShowGatewayModal(false)}
               >
               Confirm
             </button>
           </div>
         </div>
       </Modal.Body>
     </Modal> */}
    </>
  );
};

export default PaymentMethod;